const markdownMap: Record<string, string> = {
  "charte-ethique": "/assets/markdowns/charte-ethique.md",
  "a-propos": "/assets/markdowns/a-propos.md",
  "conseils": "/assets/markdowns/conseils.md",
  "conditions-generales-utilisation": "/assets/markdowns/conditions-generales-utilisation.md",
  "declaration-accessibilite": "/assets/markdowns/declaration-accessibilite.md",
  "mentions-legales": "/assets/markdowns/mentions-legales.md",
  "utilisation-cookies": "/assets/markdowns/utilisation-cookies.md",
  // Ajoute d'autres mappings ici
};

export default markdownMap; 